import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "submit"]

  connect() {
    this.refresh()
  }

  refresh() {
    const ready = this.fieldTargets
      .filter((field) => !field.disabled && !field.closest("[hidden]"))
      .every((field) => field.value.trim().length > 0)
    if (this.hasSubmitTarget) this.submitTarget.disabled = !ready
  }
}
